<template>
    <div class="pay-detail">
        <page-background />
        <a-spin tip="支付页面跳转中..." :spinning="spinning">
            <div class="detail-box">
                <p>商品订单：<span style="color: #444546">{{orderInfo.orderCode}}</span></p>
                <p>支付金额：<span style="color: #E85A26;font-size: 24px">{{orderInfo.price}}</span></p>

                <p v-for="(item,key) in orderInfo.courseList" :key="key">
                    <a-row :guter="{ xs: 8, sm: 8, md: 8, lg: 16,xl:32 }">
                        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">课程名称：{{item.courseTitle}}</a-col>
                        <a-col :span="12">
                            <div v-if="orderInfo.productType == 0">
                                价格：
                                <span style="color: #E85A26;font-size: 18px;margin: 0 10px 0 0">￥{{item.actuallyPaid}}</span>
                            </div>
                        </a-col>
                    </a-row>
                </p>
                <a-divider />
                <p>支付方式：<br>
                    <a-button @click="toPay"><img src="../assets/img/支付宝.png" alt=""> 支付宝支付</a-button>
                </p>
            </div>
        </a-spin>
    </div>
</template>

<script>
    // import {orderDetail} from "@api/shopping-api"
    import {payCourse} from "@api/shopping-api"
    import {orderDetailPC} from "@api/shopping-api"
    import {showError} from "@utils/msg";

    export default {
        name: "payDetail",
        data() {
            return {
                //支付成功跳转界面
                returnUrl: "http://10.9.0.9:8087",
                //控制等待框
                spinning: false,
                //订单内容
                orderInfo: {}
            }
        },
        created() {
            this.returnUrl = location.protocol + "//" + location.host + "/other/pay-succeed"
            orderDetailPC(this.$route.params.orderId).then((res) => {
                if (res.code === 0) {
                    this.orderInfo = res.data;
                } else {
                    showError("获取订单出错", res.msg)
                }
            })
        },
        methods: {
            //    去支付
            toPay() {
                this.spinning = true;
                payCourse(this.$route.params.orderId, this.returnUrl).then((res) => {
                    this.spinning = false;
                    if (res.code === 0) {
                        //跳转支付宝
                        window.location.href = res.url.body
                    } else {
                        showError("跳转失败", res.msg);
                    }
                })
            }
        }

    }
</script>

<style scoped lang="less">
    .pay-detail {
        background: #F4F4F4;
        padding: 20px;
        font-size: 16px;

        .detail-box {
            width: 1062px;
            margin: auto;
            padding: 50px 100px;
            background: #FFFFFF;

            p {
                margin-bottom: 20px;
            }

            button {
                width: 210px;
                height: 60px;
                margin: 30px;

                img {
                    width: 42px;
                    height: 37px;
                    margin-right: 20px;
                }
            }

            .two-dimensional-code {
                margin: 30px;
                width: 208px;
            }

        }
    }

    @import '../styles/variable.less';
    @media screen and (max-width: @screen-lg) {

        .pay-detail {
            width: 100%;
            padding: 10px;
            font-size: 16px;

            .detail-box {
                width: 100%;
                /*width: 1062px;*/
                /*margin: auto;*/
                margin: 0;
                padding: 20px;
                background: #FFFFFF;

                p {
                    margin-bottom: 20px;
                }

                button {
                    width: 210px;
                    height: 60px;
                    margin: 30px;

                    img {
                        width: 42px;
                        height: 37px;
                        margin-right: 20px;
                    }
                }

                .two-dimensional-code {
                    margin: 30px;
                    width: 208px;
                }

            }
        }
    }


</style>
